import { Fragment } from "react";
import { Link } from "react-router-dom";
import { url } from "../../Config/Config";
import { encodeID } from "../../utils/Helper";
import React from "react";
import { useIntl } from "react-intl";

export const LinkButtons = ({
  pageLink,
  subPageLink,
  pageID,
  showEdit,
  showView,
  showDelete,
  onClick,
  showTicket,
  showEdit_disable,
}: any) => {
  const intl = useIntl();
  return (
    <Fragment>
      {showEdit && (
        <Link
          to={`${url}/${pageLink}/${encodeID(pageID)}`}
          className="btn btn-primary me-2"
        >
          <i className="fas fa-edit" title={intl.formatMessage({ id: "edit" })}></i>
        </Link>
      )}

      {showEdit_disable && (
        <a className="btn btn-primary me-2">
          <i className="fas fa-edit" title={intl.formatMessage({ id: "edit" })}></i>
        </a>
      )}
      {showView && (
        <Link
          to={`${url}/${pageLink}/${encodeID(pageID)}`}
          className="btn btn-info me-2"
        >
          <i className="fas fa-eye" title={intl.formatMessage({ id: "view" })}></i>
        </Link>
      )}
      {showDelete && (
        <Link
          to={`${url}/${pageLink}`}
          className="btn btn-danger-delete text-white"
        >
          <i
            className="fas fa-trash-alt"
            title={intl.formatMessage({ id: "delete" })}
          ></i>
        </Link>
      )}
      {showTicket && (
        <Link
          to={`${url}/${pageLink}/${encodeID(pageID)}/${subPageLink}`}
          className="btn btn-info me-2"
        >
          <i
            className="bx bxs-coupon"
            title={intl.formatMessage({ id: "ticket" })}
          ></i>
        </Link>
      )}
    </Fragment>
  );
};
